import auth from '@/router/auth'
import BlogIndex from '@/components/notifications/Index'
import BlogCreate from '@/components/notifications/Create'
import BlogUpdate from '@/components/notifications/Update'
import BlogShow from '@/components/notifications/Show'

export default [
  {
    path: '/notifications',
    name: 'notifications-index',
    component: BlogIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/notifications/create',
    name: 'notifications-create',
    component: BlogCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/notifications/update/:id',
    name: 'notifications-update',
    component: BlogUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/notifications/show/:id',
    name: 'notifications-show',
    component: BlogShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/notifications/router.js